export const Symbols = {
    VueI18n: Symbol('VueI18n'),
};

export const EXCEED_USAGE_ERROR_CODE = 11120118;

export const HISTORY_DEFAULT_PAGE = 1;

export const HISTORY_LIST_LIMIT = 100;

export const TITLE_SLICE_LENGTH = 20;

export const OPEN_DELAY = 500;

export const HISTORY_TYPE_MAP = {
    AI_TRANSLATION: 'Translation',
    PATENT_DISCLOSURE: 'Disclosure generator',
};

export const PATH_MAP = {
    AI_SEARCH: 'search',
    AI_CLMS: 'clms',
    AI_IMAGE: 'image',
    AI_TRANSLATION: 'translation',
    PATENT_DISCLOSURE: 'disclosure',
};

export const TASK_TYPE = {
    SEARCH: 'AI_SEARCH',
    CLMS: 'AI_CLAIM',
    IMAGE: 'AI_IMAGE',
    TRANSLATION: 'AI_TRANSLATION',
    DISCLOSURE: 'PATENT_DISCLOSURE',
};